import { createContext } from "react";

export const LocalsContext = createContext<App.Locals>({
  user: null,
  session: null,
  locale: "en-US",
  country: null,
  continent: null,
});
